<div class="profile-navigation">
  <div class="item active">
    <p class="subtitle-14">{{ "telemedicine.navigation.chat" | translate }}</p>
  </div>

  <div class="item" (click)="navigateToChatHistory()">
    <p class="subtitle-14">{{ "telemedicine.navigation.history" | translate }}</p>
  </div>
</div>

<div class="tab-content">
  <div #chatContainer class="embedded-chat">
    <mat-spinner></mat-spinner>
  </div>
</div>
